const axios = require("axios");

export const client = axios.create({
   //  baseURL: 'https://artcode.orks.tk'
    baseURL: 'https://novacarrierscorp.com/'
});
